import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import * as firebase from 'firebase'
import DropDownMenu from 'material-ui/DropDownMenu'
import MenuItem from 'material-ui/MenuItem'

import timezones from './timezones'
import withSettingsCard from '../withSettingsCard'

class Calendar extends React.Component {

  static defaultProps = {
    timezone: 'America/Los_Angeles'
  }

  static propTypes = {
    teamId: PropTypes.string.isRequired,
    timezone: PropTypes.string,
    style: PropTypes.object
  }

  handleChange = (event, index, value) => {
    event.preventDefault()
    firebase.database()
      .ref(`teams/${this.props.teamId}/metadata/timezone`)
      .set(value)
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.header}>Calendar</div>
        <div style={styles.subheader}>What is your primary time zone?</div>
        <DropDownMenu
          value={this.props.timezone}
          onChange={this.handleChange}
          style={styles.dropdown}
          autoWidth={false}>
          { timezones.map((timezone, index) =>
            <MenuItem
              key={index}
              value={timezone.utc[0]}
              label={timezone.text}
              primaryText={timezone.text} />)
          }
        </DropDownMenu>
      </div>
    )
  }

}

const styles = {
  container: {
    textAlign: 'left',
    paddingTop: 20,
    paddingBottom: 20
  },
  header: {
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 8,
    marginLeft: 24
  },
  subheader: {
    fontSize: 14,
    fontWeight: 300,
    marginLeft: 24
  },
  dropdown: {
    width: 400
  }
}

const mapStateToProps = state => ({
  teamId: state.firebase.team.metadata.value.id,
  timezone: state.firebase.team.metadata.value.timezone
})

export default connect(mapStateToProps)(withSettingsCard(Calendar))



// WEBPACK FOOTER //
// ./src/settings/modules/calendar/Calendar.js